import React from "react";

function formatOpenedWhen(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const now = new Date();
    const full = d.toLocaleString(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
    const startOf = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
    const days = Math.round((startOf(now) - startOf(d)) / 86400000);
    let ago = "";
    if (days <= 0) ago = "today";
    else if (days === 1) ago = "1 day ago";
    else ago = `${days} days ago`;
    return `${full} (${ago})`;
  } catch {
    return String(iso);
  }
}

export default function NotificationNoticeReader({ notice, onBack, channelLabel }) {
  const body = String(notice?.message ?? "").replace(/\r\n/g, "\n").trim();
  const channel = channelLabel(notice?.channel);

  return (
    <article
      id={notice?.id ? `notice-reader-${notice.id}` : undefined}
      className="inv-notice-reader"
      aria-label={`Notice: ${notice?.title || "Notice"}`}
    >
      <div className="inv-notice-reader__toolbar">
        <button type="button" className="inv-notice-reader__back" onClick={onBack}>
          ← Back to inbox
        </button>
      </div>

      <header className="inv-notice-reader__subject-bar">
        <h2 className="inv-notice-reader__title">{notice?.title || "Notice"}</h2>
        <span className="inv-notice-reader__inbox-label">{channel}</span>
      </header>

      <div className="inv-notice-reader__from-row">
        <div className="inv-notice-reader__from-left">
          <span className="inv-notice-reader__avatar" aria-hidden>
            NH
          </span>
          <div className="inv-notice-reader__from-meta">
            <span className="inv-notice-reader__from-name">Need Healthcare</span>
            <span className="inv-notice-reader__to">
              to <span className="inv-notice-reader__to-you">me</span>
            </span>
          </div>
        </div>
        <time className="inv-notice-reader__when" dateTime={notice?.created_at || undefined}>
          {formatOpenedWhen(notice?.created_at)}
        </time>
      </div>

      <div className="inv-notice-reader__body">
        {body ? (
          <div className="inv-notice-reader__message">{body}</div>
        ) : (
          <p className="inv-notice-reader__paragraph inv-notice-reader__paragraph--empty">No message content.</p>
        )}
      </div>
    </article>
  );
}
